// import 'core-js/stable';
// import 'regenerator-runtime/runtime';

import './styles';

import * as React from 'react';
import { createRoot } from 'react-dom/client';

import getRoutes from './routes';
import getProvider from 'kodyl-js/react-ssr/provider';
import createStore from './redux/create';
import ApiClient from './redux/api-client';

import registerServiceWorker from './registerServiceWorker';

if (__DEV__) {
  global.React = React;
}

const dest = document.getElementById('content');

const store = createStore({
  client: new ApiClient()
});

const routes = getRoutes(store);

// const DevTools =
//   __DEV__ && __DEVTOOLS__ ? require('./redux/dev-tools').default : null;

const { App /*, component: provider*/, fetchData } = getProvider({
  store,
  routes
  // DevTools
});

const root = dest ? createRoot(dest) : null;

const __appReady = fetchData()
  .then(() => {
    if (root) {
      root.render(<App />);
    }
  })
  .catch((err) => {
    if (__DEV__) {
      console.error(err);
    }
  });

if (__TEST__) {
  global.__appReady = __appReady;
}

registerServiceWorker(); // Runs register() as default function